import type { ReactElement, SVGProps } from "react";

export function CashbackBadgeIcon(
  props: SVGProps<SVGSVGElement>,
): ReactElement {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="70" height="70" rx="35" fill="#F0FDF6" />
      <path
        d="M45.0088 21.1638L51.8662 22.6902L51.1641 29.7429L55.8154 34.9998L51.1641 40.2576L51.8662 47.3093L45.0088 48.8357L41.4717 54.8933L35.0029 52.156L28.5332 54.8933L24.9961 48.8357L18.1387 47.3093L18.8408 40.2576L14.1895 34.9998L18.8408 29.7429L18.1387 22.6902L24.9961 21.1638L28.5332 15.1072L35.0029 17.8445L41.4717 15.1072L45.0088 21.1638ZM40.0713 36.9441C39.2035 36.9441 38.4654 37.2479 37.8574 37.8552C37.2495 38.4628 36.9453 39.2006 36.9453 40.0681C36.9453 40.9359 37.2492 41.674 37.8564 42.282C38.4641 42.8899 39.2018 43.1941 40.0693 43.1941C40.9372 43.1941 41.6753 42.8902 42.2832 42.283C42.8911 41.6753 43.1953 40.9376 43.1953 40.0701C43.1953 39.2022 42.8915 38.4642 42.2842 37.8562C41.6765 37.2482 40.9388 36.9441 40.0713 36.9441ZM27.2354 40.1658L30.251 43.1824L43.1836 30.2498L40.168 27.2341L27.2354 40.1658ZM30.3496 27.2224C29.4819 27.2224 28.7436 27.5255 28.1357 28.1326C27.5279 28.7401 27.2237 29.4781 27.2236 30.3455C27.2236 31.2133 27.5275 31.9514 28.1348 32.5593C28.7424 33.1673 29.4801 33.4714 30.3477 33.4714C31.2153 33.4713 31.9527 33.1675 32.5605 32.5603C33.1685 31.9527 33.4727 31.215 33.4727 30.3474C33.4726 29.4797 33.1688 28.7414 32.5615 28.1335C31.9541 27.526 31.2168 27.2225 30.3496 27.2224Z"
        fill="#128351"
      />
    </svg>
  );
}
